export default __webpack_public_path__ + "static/media/Vector.603b2625.svg";